module.exports = __webpack_public_path__ + "img/cf-cb_small.7e5c3852.png";